<app-loader [isLoading]="isLoading"></app-loader>
@if(isUuid){
<router-outlet></router-outlet>
} @else {
<div class="header">
    <app-title [title]="title" [subtitle]="subtitle"></app-title>
    @if (myroles.can_write) {
    <div class="top">
        <div class="boton">
            <button class="b1" mat-button (click)="addPrice()">Añadir precios</button>
        </div>
    </div>
    }
</div>
<div class="content form">
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
        <mat-tab label="En uso">
            <table mat-table [dataSource]="activeDataSource" matSort (matSortChange)="announceSortChange($event)"
                class="mat-elevation-z8 table">

                <!-- Columna de Precio -->
                <ng-container matColumnDef="price">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        PRECIO
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <button mat-flat-button id="button">
                            <span style="font-size: 16px;">{{element.price}}€</span>
                        </button>
                    </td>
                </ng-container>

                <ng-container matColumnDef="price_company">
                    <th mat-header-cell *matHeaderCellDef>
                        EMPRESA
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <button mat-flat-button id="button">
                            <span style="font-size: 16px;">{{element.price_company}}€</span>
                        </button>
                    </td>
                </ng-container>

                <!-- Columna de Tipo -->
                <ng-container matColumnDef="type">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        TIPO
                    </th>
                    <td mat-cell *matCellDef="let element">
                        @if(element.meal_type === 'LUNCH'){
                        <button mat-flat-button id="button">
                            <span style="font-size: 16px;">Comida</span>
                        </button>
                        }@else {
                        <button mat-flat-button id="button">
                            <span style="font-size: 16px;">Desayuno</span>
                        </button>
                        }
                    </td>
                </ng-container>

                <!-- Columna de Autor -->
                <ng-container matColumnDef="author">
                    <th mat-header-cell *matHeaderCellDef>
                        AUTOR
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <span style="font-size: 16px;">{{element.author_external_id | qeqPipe}}</span>
                    </td>
                </ng-container>

                <!-- Columna de Autor -->
                <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef>
                        ID
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <span style="font-size: 16px;">{{element.author_external_id}}</span>
                    </td>
                </ng-container>

                <!-- Columna de Creación -->
                <ng-container matColumnDef="start">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        VÁLIDO DESDE
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <span style="font-size: 16px;">{{element.valid_from | customPipe}}</span>
                    </td>
                </ng-container>


                <!-- Columna de Fechas Válidas -->
                <ng-container matColumnDef="finish">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        VÁLIDO HASTA
                    </th>
                    <td mat-cell *matCellDef="let element">
                        @if (element.valid_until === null) {
                        <span style="font-size: 16px;">No definido</span>
                        } @else {
                        <span style="font-size: 16px;">{{element.valid_until | customPipe}}</span>
                        }
                    </td>
                </ng-container>

                <!-- Columna de Acciones -->
                <ng-container matColumnDef="acciones">
                    <th mat-header-cell *matHeaderCellDef>
                    </th>
                    <td mat-cell *matCellDef="let element">
                        @if (myroles.can_write) {
                        <button mat-icon-button class="acciones" (click)="goToEdit(element.id)"><mat-icon
                                svgIcon="edit"></mat-icon></button>
                        }
                        @if (myroles.can_delete) {
                        <button mat-icon-button class="acciones"
                            (click)="deleteSelected(element.id, element.title)"><mat-icon
                                svgIcon="delete"></mat-icon></button>}
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;">
                </tr>
            </table>
        </mat-tab>

        <mat-tab label="Histórico">
            <!-- Paginator specifically for historical prices -->
            <mat-paginator #historicalPaginator [pageSizeOptions]="[25, 50, 100]"
                aria-label="Select page of historical prices" class="paginator-field">
            </mat-paginator>

            <table mat-table [dataSource]="historicalDataSource" matSort (matSortChange)="announceSortChange($event)"
                class="mat-elevation-z8 table">

                <!-- Columna de Precio -->
                <ng-container matColumnDef="price">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        PRECIO
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <button mat-flat-button id="button">
                            <span style="font-size: 16px;">{{element.price}}€</span>
                        </button>
                    </td>
                </ng-container>

                <ng-container matColumnDef="price_company">
                    <th mat-header-cell *matHeaderCellDef>
                        EMPRESA
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <button mat-flat-button id="button">
                            <span style="font-size: 16px;">{{element.price_company}}€</span>
                        </button>
                    </td>
                </ng-container>

                <!-- Columna de Tipo -->
                <ng-container matColumnDef="type">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        TIPO
                    </th>
                    <td mat-cell *matCellDef="let element">
                        @if(element.meal_type === 'LUNCH'){
                        <button mat-flat-button id="button">
                            <span style="font-size: 16px;">Comida</span>
                        </button>
                        }@else {
                        <button mat-flat-button id="button">
                            <span style="font-size: 16px;">Desayuno</span>
                        </button>
                        }
                    </td>
                </ng-container>

                <!-- Columna de Autor -->
                <ng-container matColumnDef="author">
                    <th mat-header-cell *matHeaderCellDef>
                        AUTOR
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <span style="font-size: 16px;">{{element.author_external_id | qeqPipe}}</span>
                    </td>
                </ng-container>

                <!-- Columna de Autor -->
                <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef>
                        ID
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <span style="font-size: 16px;">{{element.author_external_id}}</span>
                    </td>
                </ng-container>

                <!-- Columna de Creación -->
                <ng-container matColumnDef="start">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        VÁLIDO DESDE
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <span style="font-size: 16px;">{{element.valid_from | customPipe}}</span>
                    </td>
                </ng-container>


                <!-- Columna de Fechas Válidas -->
                <ng-container matColumnDef="finish">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        VÁLIDO HASTA
                    </th>
                    <td mat-cell *matCellDef="let element">
                        @if (element.valid_until === null) {
                        <span style="font-size: 16px;">No definido</span>
                        } @else {
                        <span style="font-size: 16px;">{{element.valid_until | customPipe}}</span>
                        }
                    </td>
                </ng-container>

                <!-- Columna de Acciones -->
                <ng-container matColumnDef="acciones">
                    <th mat-header-cell *matHeaderCellDef>
                    </th>
                    <td mat-cell *matCellDef="let element">
                        @if (myroles.can_write) {
                        <button mat-icon-button class="acciones" (click)="goToEdit(element.id)"><mat-icon
                                svgIcon="edit"></mat-icon></button>
                        }
                        @if (myroles.can_delete) {
                        <button mat-icon-button class="acciones"
                            (click)="deleteSelected(element.id, element.title)"><mat-icon
                                svgIcon="delete"></mat-icon></button>}
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;">
                </tr>
            </table>
        </mat-tab>"
    </mat-tab-group>
</div>

}